import { LoginService } from './../../_services/login/login.service';
import { LoginRequestModel } from './../../_models/login/LoginRequestModel';
import { GlobalService } from './../../_global/global.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as shajs from 'sha.js';

@Component({
    templateUrl: './validatelogin.component.html',
})
export class ValidateLoginComponent implements OnInit {
    offersList = new Array<any[]>();
    offerDetails = false;
    urlParamData: string;
    loading = true;
    currentUser: any;
    loginData;
    model: any = {};
    uiList = new Array<any>();
    uipermissionList = new Array<any>();

    private _gs: GlobalService = new GlobalService();

    constructor(private _router: Router, private _loginService: LoginService,
    ) {

        // this.route.queryParams.subscribe(params => {
        //     this.urlParamData = params;
        //     console.log(this.urlParamData);

        // });

    }

    ngOnInit() {
        //this.getOffersList();
        // this.urlParamData = this._router.url;
        // this.urlParamData = this.urlParamData.substring(15);
        const lastEqualSignIndex = this._router.url.lastIndexOf('/');
        this.urlParamData = this._router.url.substr(lastEqualSignIndex + 1);
        this.loginData = JSON.parse(atob(this.urlParamData));
        console.log(this.urlParamData);
        // this.uipermissionList = this._gs.currentUser.uiPermissions;


        // setTimeout(() => {
        //     this.loading = false;
        // }, 1000);

        this.signin();
    }


    //LOGIN POST REQUEST
    signin() {
        // crypto.createHash('SHA-256');

        this.loading = true;
        this.model.email = this.loginData["email"].trim();
        this.model.password = this.loginData["password"].trim();
        const loginModel = new LoginRequestModel(
            this.model.email,
            this.model.password
        );

        localStorage.setItem(
            "X-PORTAL-TOKEN",
            shajs('sha256').update('8c6976e5b5410415bde908bd4dee15dfb167a9c873fc4bb8a81f6f2ab448a918' + this.model.email).digest('hex')
        )
        this._loginService.login(loginModel).subscribe(result => {
            this.currentUser = result.json();
            this.uiList = this.currentUser.uiPermissions;
            if (this.currentUser['partnerStatus'] == "READ_ONLY") {
                // if(false){
                this.loading = false;
                swal(
                    '',
                    'Your online access to WSFX Partner portal is under process. You are requested to call us on +91-9136090052 or mail us on support@wsfx.in to activate your account.',
                    'info'
                );
            } else {
                if (
                    this.currentUser.photo === null ||
                    this.currentUser.photo === undefined
                ) {
                    if (this.currentUser.firstName && this.currentUser.lastName) {
                        this.currentUser.photo =
                            this.currentUser.firstName.toString().charAt(0) +
                            this.currentUser.lastName.toString().charAt(0);
                        this.currentUser.photo =
                            "data:image/JPEG" + this.currentUser.photo;
                    }
                }
                localStorage.setItem("currentUser", JSON.stringify(this.currentUser));

                localStorage.setItem(
                    "X-AUTH-TOKEN",
                    JSON.stringify({ token: result.headers.get("X-AUTH-TOKEN") })
                );
                this.loading = false;
                this._gs.currentUser = this.currentUser;

                localStorage.setItem("timeOutInSeconds", this.currentUser.timeOutInSeconds);
                localStorage.setItem("lastapirequeststart", "true");
                localStorage.setItem("tourOperatorReferrer", this.currentUser.tourOperatorReferrer + "");

                localStorage.setItem("lastapirequest", Date.now().toString());
                localStorage.setItem("showFxCalculator", this.currentUser.partner.showFxCalculator + "");
                localStorage.setItem("bulkOrderAllowed", this.currentUser.partner.bulkOrderAllowed + "");
                localStorage.setItem("showRateRange", this.currentUser.partner.showRateRange + "");
                this.uiList.push({ data: this.currentUser.uiPermissions });
                this._router.navigate(["/dashboard"]);
            }
        },
            error => {
                error

                this.loading = false;
                let errorReason = JSON.parse(error._body).reason;
                if (errorReason == 'INACTIVE_PARTNER' || errorReason == 'USER_NOT_ACTIVE') {
                    swal(
                        'Error',
                        'This account is <b>INACTIVE</b>.<br/> Please contact your Admin for further assistance!',
                        'error'
                    );
                }
                if (errorReason == 'INVALID_CREDENTIALS' || errorReason == 'INVALID_REQUEST_PARAMETER') {
                    swal("Login Error", "Invalid Username or Password", "error");
                }
                // if (errorReason == "PASSWORD_NOT_UPDATED") {
                //     LoginCustom.displayLoginResetPassword();
                // }
                // if (errorReason == "PORTAL_USER_MISMATCH") {
                //     let msg = JSON.parse(error._body).message;

                //     swal("Login Error", msg, "error");
                // }
            }
        );
    }



}


// WEBPACK FOOTER //
// ./src/app/auth/validateLogin/validatelogin.component.ts